//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
export default {
  data() {
    return {
      end: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        name: '',
        loading: false
      },
      list: [],
      trafficList: {
        火车: {
          name: '火车',
          Ename: 'TRAIN',
          img: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/vitality/train.png')
          // color: 'linear-gradient(-258deg, #6fffbb 0%, #1fccd7 100%)'
        },
        飞机: {
          name: '飞机',
          Ename: 'PLANE',
          img: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/vitality/plane.png'),
          // color: 'linear-gradient(-258deg, #98e6ff 0%, #4c99f3 100%)',
          code: ''
        },
        公交: {
          name: '公交',
          Ename: 'BUS',
          img: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/vitality/commuterBus.png'),
          // color: 'linear-gradient(-245deg, #ffea9d 0%, #ffb136 100%)',
          code: ''
        },
        自驾车: {
          name: '自驾车',
          Ename: 'CAR',
          img: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/vitality/car.png'),
          // color: 'linear-gradient(-258deg, #fbc4ae 0%, #ff7777 100%)',
          code: ''
        },
        巴士: {
          name: '巴士',
          Ename: 'COACH',
          img: ('http://lishiots.oss-cn-hangzhou.aliyuncs.com/webstatic/vitality/bus.png'),
          // color: 'linear-gradient(-258deg, #98e6ff 0%, #4c99f3 100%)',
          code: ''
        }
      }
    }
  },
  onLoad() {
    this.queryData()
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.page.count) {
      this.queryData()
    }
  },
  components: {
    uniLoadMore
  },
  methods: {
    handleClick(item) {
      uni.navigateTo({
        url: `/pages/traffic/detail?id=${item.id}`
      })
    },
    queryData(status) {
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/cms/touristtraffic/getByTenantId',
        data: {
        }
      }).then(data => {
        this.page.count = data.count
        this.list.push.apply(this.list, data.data)
        if (this.list.length >= this.page.count) {
          this.end = true
        }
        this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        this.page.loading = false
      })
    }
  }
}
